import { Close } from '@carbon/icons-react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles
} from '@material-ui/core';
import React from 'react';

interface AnnotationDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const AnnotationDeleteDialog: React.FunctionComponent<AnnotationDeleteDialogProps> = ({
  open,
  onClose,
  onDelete
}) => {
  const { paper, title, content, actions } = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper }}
      disableBackdropClick
    >
      <DialogTitle disableTypography className={title}>
        <CustomizedTypography variant="h4" fontWeight="700">
          주석 전체삭제
        </CustomizedTypography>
        <IconButton className="close-button" size="small">
          <Close size={24} color={colorSet.gray900} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={content}>
        <CustomizedTypography variant="subtitle1" color="textPrimary">
          최상위 주석을 삭제하면 아래 모든 답글이 삭제됩니다. <br />
          정말 삭제하시겠습니까?
        </CustomizedTypography>
      </DialogContent>
      <DialogActions className={actions}>
        <CustomizedButton
          variant="contained"
          color="default"
          size="large"
          fullWidth
          onClick={onClose}
        >
          취소
        </CustomizedButton>
        <CustomizedButton
          variant="contained"
          color="error"
          size="large"
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          삭제하기
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
};

export default AnnotationDeleteDialog;

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: '476px',
    minWidth: '343px',
    borderRadius: '18px'
  },
  title: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '28px 24px',
    '& .close-button': {
      position: 'absolute',
      top: '18px',
      right: '18px'
    }
  },
  content: {
    padding: '0px 24px 24px',
    borderBottom: `1px solid ${colorSet.gray400}`
  },
  actions: {
    display: 'flex',
    gap: '8px',
    padding: '16px 24px'
  }
}));
